import { get } from 'lodash';

import { MANAGED_ERRORS } from '../core/constants';
import { AnyError } from '../core/types';

/**
 * Get the error status.
 *
 * @param {AnyError} error
 * @returns {number | undefined}
 */
export function getErrorStatus(error: AnyError): number | undefined {
  return get(error, 'response.status');
}

/**
 * Check if it is a specific API error to manage and render as
 * status and specific message page or generic error page.
 *
 * @param {AnyError} error
 * @returns {boolean}
 */
export function isErrorToManage(error: AnyError): boolean {
  const errorStatus = getErrorStatus(error);

  if (!errorStatus) {
    return true;
  }

  return MANAGED_ERRORS.includes(errorStatus);
}
